import IsTelephoneAvailable from '@/services/users/telephoneService/IsTelephoneAvailable';
import LegacyIsTelephoneAvailable from '@/services/users/telephoneService/LegacyIsTelephoneAvailable';

export default class TelephoneService {
    /**
     * Check if requested telephone is available.
     *
     * @param {String} telephone
     *
     * @deprecated
     *
     * @returns {Boolean}
     */
    async legacyIsTelephoneAvailable(telephone) {
        return (new LegacyIsTelephoneAvailable()).handle(telephone);
    }

    /**
     * Check if requested telephone is available.
     *
     * @param {String} telephone
     *
     * @returns {Promise}
     */
    static isTelephoneAvailable(telephone) {
        return (new IsTelephoneAvailable()).handle(telephone);
    }
}
